import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";

/** Countdown, starting / sold / current bid and the Place Bid / Register to Bid button. */
export default function BidPanel({
  LotStatus,
  RegisterToBid,
  auctionType,
  current,
  handleClickOpen,
  hp,
  isDone,
  isWidraw,
  showHp,
  startingPrice,
  status,
  timeLeft,
  token,
}) {
  return (
    <>
      {isWidraw !== 1 && (
        <div style={{ paddingBottom: 25, borderRadius: "4px" }}>

          {auctionType === "TIME_AUCTION" &&
            (timeLeft.days > 0 ||
              timeLeft.hours > 0 ||
              timeLeft.minutes > 0 ||
              timeLeft.seconds > 0) && (
              <Box
                sx={{
                  mb: 2.5,
                  pb: 2,
                  borderBottom: "1px solid #e0e0e0",
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: 800,
                    color: "#888",
                    mb: 1,
                    letterSpacing: "1px",
                  }}
                >
                  AUCTION ENDS IN
                </Typography>
                <Stack
                  direction="row"
                  justifyContent="center"
                  spacing={2.5}
                >
                  <Box>
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: 800 }}
                    >
                      {timeLeft.days}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "9px", color: "#aaa" }}
                    >
                      D
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: 800 }}
                    >
                      {timeLeft.hours}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "9px", color: "#aaa" }}
                    >
                      H
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: 800 }}
                    >
                      {timeLeft.minutes}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "9px", color: "#aaa" }}
                    >
                      M
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: 800 }}
                    >
                      {timeLeft.seconds}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "9px", color: "#aaa" }}
                    >
                      S
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            )}

          <div className="d-flex justify-content-between align-items-center">
            <span
              style={{
                fontSize: "14px",
                fontWeight: 800,
                color: "#777",
              }}
            >
              {parseInt(showHp) === 1 && LotStatus === "SOLD"
                ? "SOLD"
                : "STARTING BID"}
            </span>
            <span style={{ fontSize: "16px", fontWeight: 700 }}>
              ₱{" "}
              {parseInt(showHp) === 1 && LotStatus === "SOLD"
                ? (hp || 0).toLocaleString()
                : (startingPrice || 0).toLocaleString()}
            </span>
          </div>


          {token &&
            current !== 0 &&
            isDone !== 1 &&
            !(
              status === "ended_auction" || LotStatus === "CLOSED"
            ) && (
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  marginTop: "12px",
                  paddingTop: "12px",
                  borderTop: "1px dashed #d0d0d0",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: 800,
                    color: "#777",
                  }}
                >
                  CURRENT BID
                </span>
                <span style={{ fontSize: "18px", fontWeight: "900" }}>
                  ₱{parseInt(current).toLocaleString()}
                </span>
              </div>
            )}
        </div>
      )}


      <div style={{ marginTop: "15px" }}>
        {isWidraw !== 1 && (
          <div style={{ marginTop: 15 }}>
            {isDone === 1
              ? ""
              : status === "ended_auction" || LotStatus === "CLOSED"
              ? ""
              : null}

            {token !== null
              ? status !== "ended_auction" &&
                (parseInt(showHp) === 0 ||
                  LotStatus === "PENDING" ||
                  isWidraw === 0) &&
                isDone !== 1 && (
                  <Button
                    onClick={handleClickOpen}
                    sx={{
                      width: "100%",
                      padding: "16px",
                      backgroundColor: "#333",
                      color: "#fff",
                      fontWeight: 700,
                      borderRadius: "4px",
                      textTransform: "none", // Para hindi maging all-caps kung ayaw mo
                      "&:hover": {
                        backgroundColor: "#000", // Kulay kapag naka-hover
                        opacity: 0.9,
                      },
                    }}
                  >
                    PLACE BID
                  </Button>
                )
              : status !== "ended_auction" &&
                isDone !== 1 && (
                  <Button
                    onClick={() => RegisterToBid()}
                    sx={{
                      width: "100%",
                      padding: "16px",
                      backgroundColor: "#333",
                      color: "#fff",
                      fontWeight: 700,
                      borderRadius: "4px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#000", // Kulay kapag naka-hover
                        opacity: 0.9,
                      },
                    }}
                  >
                    REGISTER TO BID
                  </Button>
                )}
          </div>
        )}
      </div>


    </>
  );
}
